var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBachartawhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.79 51.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 172.27,
    cy: 33.94,
    r: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.08,17.51h7.67c4.22,0,6.83,2.4,6.81,6.22,.01,2.59-1.18,4.43-3.25,5.38l3.93,7.16h-4.85l-3.45-6.45h-2.46v.6h-4.4v-12.9Zm6.74,8.78c2.09,.01,3.19-.8,3.19-2.56s-1.1-2.64-3.19-2.64h-2.33v5.21h2.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96.98,
    cy: 33.94,
    r: 2.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.24,
    y: 11.87,
    width: 4.38,
    height: 4.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.18,
    y: 17.51,
    width: 4.38,
    height: 4.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.08,17.51h7.75c4.21,0,6.37,1.92,6.37,4.77,0,2.14-1.45,3.61-3.5,4.04v.18c2.25,.1,4.22,1.81,4.22,4.53,0,3.02-2.34,5.23-6.5,5.23h-8.34V17.51Zm7.02,7.75c1.5-.01,2.59-.8,2.59-2.15,0-1.27-.97-2.07-2.54-2.07h-2.67v4.22h2.62Zm.29,7.44c2.01,0,2.93-.82,2.93-2.15,0-1.48-1.09-2.42-2.85-2.41h-2.98v4.56h2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.22,36.27l6.37-18.76h5.86l6.35,18.76h-4.74l-1.27-4.02h-6.53l-1.27,4.02h-4.77Zm11.5-7.38l-2.12-6.74h-.16l-2.12,6.74h4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.79,17.51h7.67c4.22,0,6.83,2.4,6.81,6.22,.01,2.59-1.18,4.43-3.25,5.38l3.93,7.16h-4.85l-3.45-6.45h-2.46v.6h-4.4v-12.9Zm6.74,8.78c2.09,.01,3.19-.8,3.19-2.56s-1.1-2.64-3.19-2.64h-2.33v5.21h2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.49,21.14c-2.76-.01-4.46,2.1-4.46,5.75s1.74,5.75,4.43,5.75c2.02,0,3.42-1.09,3.76-2.93l4.46,.03c-.35,3.34-3.21,6.79-8.29,6.79s-8.86-3.47-8.86-9.64,3.86-9.64,8.86-9.64c4.5,0,7.82,2.55,8.29,7.02h-4.46c-.25-1.93-1.63-3.15-3.73-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.24,17.51h4.4v7.57h7.54v-1.93h4.4v13.12h-4.4v-7.59h-7.54v7.59h-4.4V17.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.55,36.27l6.37-18.76h5.86l6.35,18.76h-4.74l-1.27-4.02h-6.53l-1.27,4.02h-4.77Zm11.5-7.38l-2.12-6.74h-.16l-2.12,6.74h4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.44,17.51h15.78v3.6h-5.7v15.16h-4.38v-15.16h-5.7v-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.21,36.27l6.37-18.76h5.86l6.35,18.76h-4.74l-1.27-4.02h-6.53l-1.27,4.02h-4.77Zm11.5-7.38l-2.12-6.74h-.16l-2.12,6.74h4.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.57,51.14L0,25.57,25.57,0l25.57,25.57-25.57,25.57ZM7.07,25.57l18.5,18.5,18.5-18.5L25.57,7.07,7.07,25.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.85,
    y: 18.21,
    width: 18.53,
    height: 5,
    transform: "translate(-8.75 20.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.21,
    y: 28.57,
    width: 18.53,
    height: 5,
    transform: "translate(-13.04 30.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.83,
    y: 25.32,
    width: 13.07,
    height: 5,
    transform: "translate(-12.83 24.67) rotate(-45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBachartawhite);
export default __webpack_public_path__ + "static/media/bachartawhite.ef4e65fec957734de3f0135c10313473.svg";
export { ForwardRef as ReactComponent };